import { useState, useEffect } from 'react'
import { useParams, Link } from 'react-router-dom'
import { fetchEventData } from '../services/api'
import EventDetail from '../components/EventDetail'

const Workshop = () => {
  const { id: eventId } = useParams()
  const [event, setEvent] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const loadEvent = async () => {
      if (!eventId) {
        setError('No event ID provided')
        setLoading(false)
        return
      }

      try {
        setLoading(true)
        const data = await fetchEventData(eventId, 'workshop')
        setEvent(data)
      } catch (err) {
        if (err.message === 'NOT_FOUND') {
          setError('NOT_FOUND')
        } else if (err.message === 'NETWORK_ERROR') {
          setError('NETWORK_ERROR')
        } else {
          setError('UNKNOWN_ERROR')
        }
        console.error(err)
      } finally {
        setLoading(false)
      }
    }

    loadEvent()
  }, [eventId])

  if (loading) {
    return <div className="loading">Loading event...</div>
  }

  if (error || !event) {
    const getErrorMessage = () => {
      if (error === 'NOT_FOUND') {
        return {
          title: 'Event Not Found',
          message: `The workshop "${eventId}" doesn't exist or has been removed.`
        }
      } else if (error === 'NETWORK_ERROR') {
        return {
          title: 'Connection Error',
          message: 'Unable to load event data. Please check your internet connection and try again.'
        }
      } else {
        return {
          title: 'Error Loading Event',
          message: 'Something went wrong while loading the event. Please try again later.'
        }
      }
    }

    const errorInfo = getErrorMessage()

    return (
      <div className="container">
        <div className="error-message">
          <h2>{errorInfo.title}</h2>
          <p>{errorInfo.message}</p>
          <div className="error-actions">
            <Link to="/workshop" className="error-btn primary">
              <i className="fas fa-arrow-left"></i>
              Browse Workshops
            </Link>
            <Link to="/" className="error-btn secondary">
              <i className="fas fa-home"></i>
              All Events
            </Link>
          </div>
        </div>
      </div>
    )
  }

  return <EventDetail event={event} eventType="workshop" />
}

export default Workshop

